export const Step = {
  BasicParameters: 1,
};

export const StepLabels = {
  [Step.BasicParameters]: 'Basic Parameters',
};
